// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file reservation.proto (package grpc.api.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Contact } from "./contact_pb";
import { file_contact } from "./contact_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file reservation.proto.
 */
export const file_reservation: GenFile = /*@__PURE__*/
  fileDesc("ChFyZXNlcnZhdGlvbi5wcm90bxILZ3JwYy5hcGkudjEiMgoVUmVzZXJ2YXRpb25BdHRhY2htZW50EgwKBG5hbWUYASABKAkSCwoDdXJsGAIgASgJIp8GCgtSZXNlcnZhdGlvbhIKCgJpZBgBIAEoAxISCgphY2NvdW50X2lkGAIgASgDEhIKCmNvbnRhY3RfaWQYAyABKAMSDgoGdGFiX2lkGAQgASgDEhMKC2NhbXBhaWduX2lkGAUgASgDEhIKCnNlcnZpY2VfaWQYBiABKAMSGAoQcmVzZXJ2YXRpb25fY29kZRgHIAEoCRIQCghkdF9iZWdpbhgIIAEoAxIOCgZkdF9lbmQYCSABKAMSEQoJZW5kX2ZpeGVkGAogASgIEhIKCnBhcnR5X3NpemUYCyABKAUSFgoOaG9sZF90YWJfaXRlbXMYDCABKAgSNgoQcmVzZXJ2YXRpb25fdHlwZRgNIAEoDjIcLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uVHlwZRI6ChJyZXNlcnZhdGlvbl9zdGF0dXMYDiABKA4yHi5ncnBjLmFwaS52MS5SZXNlcnZhdGlvblN0YXR1cxIZChFyZXNlcnZhdGlvbl9sYWJlbBgPIAEoCRIcChRyZXNlcnZhdGlvbl9jYW1wYWlnbhgQIAEoCRIXCg9kdF9wcmVfcmVzZXJ2ZWQYESABKAMSEgoKaXNfc3RhcnJlZBgSIAEoCBISCgppc19mbGFnZ2VkGBMgASgIEhEKCWlzX3VucmVhZBgUIAEoCBIaChJlbXBsb3llZV9pZF9jcmVhdGUYFSABKAMSHQoVZW1wbG95ZWVfaWRfbGFzdF9lZGl0GBYgASgDEhEKCWR0X2NyZWF0ZRgXIAEoAxIRCglkdF91cGRhdGUYGCABKAMSFgoOc3luY19pc19uZWVkZWQYGSABKAgSEQoJbm90ZV90ZXh0GBogASgJEhQKDHBheW1lbnRfaW5mbxgbIAEoCRIOCgZyYXRpbmcYHCABKAUSFQoNdGFiX2l0ZW1zX2lkcxgdIAMoAxIlCgdjb250YWN0GB4gASgLMhQuZ3JwYy5hcGkudjEuQ29udGFjdBI3CgthdHRhY2htZW50cxgfIAMoCzIiLmdycGMuYXBpLnYxLlJlc2VydmF0aW9uQXR0YWNobWVudCrKAQoRUmVzZXJ2YXRpb25TdGF0dXMSCAoETk9ORRAAEgsKB1BMQU5ORUQQARIKCgZTRUFURUQQAhIOCgpDSEVDS0VEX0lOEAMSDwoLQ0hFQ0tFRF9PVVQQBBINCglDT05GSVJNRUQQBRIRCg1OT05fQ09ORklSTUVEEAYSEAoMV0FJVElOR19MSVNUEAcSDQoJQ0FOQ0VMTEVEEAgSCgoGTk9TSE9XEAkSCAoEU1BBTRAKEgsKB0RFTEVURUQQCxILCgdQRU5ESU5HEAwqMQoPUmVzZXJ2YXRpb25UeXBlEggKBG5vbmUQABIKCgZvbmxpbmUQARIICgR1c2VyEAJCBloELjtwYmIGcHJvdG8z", [file_contact]);

/**
 * Attachment
 *
 * @generated from message grpc.api.v1.ReservationAttachment
 */
export type ReservationAttachment = Message<"grpc.api.v1.ReservationAttachment"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: string url = 2;
   */
  url: string;
};

/**
 * Describes the message grpc.api.v1.ReservationAttachment.
 * Use `create(ReservationAttachmentSchema)` to create a new message.
 */
export const ReservationAttachmentSchema: GenMessage<ReservationAttachment> = /*@__PURE__*/
  messageDesc(file_reservation, 0);

/**
 * Reservation
 *
 * @generated from message grpc.api.v1.Reservation
 */
export type Reservation = Message<"grpc.api.v1.Reservation"> & {
  /**
   * @generated from field: int64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: int64 account_id = 2;
   */
  accountId: bigint;

  /**
   * @generated from field: int64 contact_id = 3;
   */
  contactId: bigint;

  /**
   * @generated from field: int64 tab_id = 4;
   */
  tabId: bigint;

  /**
   * @generated from field: int64 campaign_id = 5;
   */
  campaignId: bigint;

  /**
   * @generated from field: int64 service_id = 6;
   */
  serviceId: bigint;

  /**
   * @generated from field: string reservation_code = 7;
   */
  reservationCode: string;

  /**
   * @generated from field: int64 dt_begin = 8;
   */
  dtBegin: bigint;

  /**
   * @generated from field: int64 dt_end = 9;
   */
  dtEnd: bigint;

  /**
   * @generated from field: bool end_fixed = 10;
   */
  endFixed: boolean;

  /**
   * @generated from field: int32 party_size = 11;
   */
  partySize: number;

  /**
   * @generated from field: bool hold_tab_items = 12;
   */
  holdTabItems: boolean;

  /**
   * @generated from field: grpc.api.v1.ReservationType reservation_type = 13;
   */
  reservationType: ReservationType;

  /**
   * @generated from field: grpc.api.v1.ReservationStatus reservation_status = 14;
   */
  reservationStatus: ReservationStatus;

  /**
   * @generated from field: string reservation_label = 15;
   */
  reservationLabel: string;

  /**
   * @generated from field: string reservation_campaign = 16;
   */
  reservationCampaign: string;

  /**
   * @generated from field: int64 dt_pre_reserved = 17;
   */
  dtPreReserved: bigint;

  /**
   * @generated from field: bool is_starred = 18;
   */
  isStarred: boolean;

  /**
   * @generated from field: bool is_flagged = 19;
   */
  isFlagged: boolean;

  /**
   * @generated from field: bool is_unread = 20;
   */
  isUnread: boolean;

  /**
   * @generated from field: int64 employee_id_create = 21;
   */
  employeeIdCreate: bigint;

  /**
   * @generated from field: int64 employee_id_last_edit = 22;
   */
  employeeIdLastEdit: bigint;

  /**
   * @generated from field: int64 dt_create = 23;
   */
  dtCreate: bigint;

  /**
   * @generated from field: int64 dt_update = 24;
   */
  dtUpdate: bigint;

  /**
   * @generated from field: bool sync_is_needed = 25;
   */
  syncIsNeeded: boolean;

  /**
   * @generated from field: string note_text = 26;
   */
  noteText: string;

  /**
   * @generated from field: string payment_info = 27;
   */
  paymentInfo: string;

  /**
   * @generated from field: int32 rating = 28;
   */
  rating: number;

  /**
   * @generated from field: repeated int64 tab_items_ids = 29;
   */
  tabItemsIds: bigint[];

  /**
   * @generated from field: grpc.api.v1.Contact contact = 30;
   */
  contact?: Contact | undefined;

  /**
   * @generated from field: repeated grpc.api.v1.ReservationAttachment attachments = 31;
   */
  attachments: ReservationAttachment[];
};

/**
 * Describes the message grpc.api.v1.Reservation.
 * Use `create(ReservationSchema)` to create a new message.
 */
export const ReservationSchema: GenMessage<Reservation> = /*@__PURE__*/
  messageDesc(file_reservation, 1);

/**
 * ReservationStatus
 *
 * @generated from enum grpc.api.v1.ReservationStatus
 */
export enum ReservationStatus {
  /**
   * @generated from enum value: NONE = 0;
   */
  NONE = 0,

  /**
   * @generated from enum value: PLANNED = 1;
   */
  PLANNED = 1,

  /**
   * @generated from enum value: SEATED = 2;
   */
  SEATED = 2,

  /**
   * @generated from enum value: CHECKED_IN = 3;
   */
  CHECKED_IN = 3,

  /**
   * @generated from enum value: CHECKED_OUT = 4;
   */
  CHECKED_OUT = 4,

  /**
   * @generated from enum value: CONFIRMED = 5;
   */
  CONFIRMED = 5,

  /**
   * @generated from enum value: NON_CONFIRMED = 6;
   */
  NON_CONFIRMED = 6,

  /**
   * @generated from enum value: WAITING_LIST = 7;
   */
  WAITING_LIST = 7,

  /**
   * @generated from enum value: CANCELLED = 8;
   */
  CANCELLED = 8,

  /**
   * @generated from enum value: NOSHOW = 9;
   */
  NOSHOW = 9,

  /**
   * @generated from enum value: SPAM = 10;
   */
  SPAM = 10,

  /**
   * @generated from enum value: DELETED = 11;
   */
  DELETED = 11,

  /**
   * @generated from enum value: PENDING = 12;
   */
  PENDING = 12,
}

/**
 * Describes the enum grpc.api.v1.ReservationStatus.
 */
export const ReservationStatusSchema: GenEnum<ReservationStatus> = /*@__PURE__*/
  enumDesc(file_reservation, 0);

/**
 * ReservationType
 *
 * @generated from enum grpc.api.v1.ReservationType
 */
export enum ReservationType {
  /**
   * @generated from enum value: none = 0;
   */
  none = 0,

  /**
   * @generated from enum value: online = 1;
   */
  online = 1,

  /**
   * @generated from enum value: user = 2;
   */
  user = 2,
}

/**
 * Describes the enum grpc.api.v1.ReservationType.
 */
export const ReservationTypeSchema: GenEnum<ReservationType> = /*@__PURE__*/
  enumDesc(file_reservation, 1);

